export enum MissingResourceType {
  VGBM = 'vgbm',
  VGBK = 'vgbk',
}
